import RootCauseModel from './rootCauseModel'

export default class PromptModel {
  public extensionPromptId: string = ''
  public extensionId: string = ''
  public promptCategory: string = ''
  public prompt: string = ''
  public details: string = ''
  public order: number = 0
  public extensionPromptRootCauses: RootCauseModel[] = []

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
